import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { RefundPricesFragment } from '@websky/graphql';
import { ExchangeRefundPriceDetails } from '@entities/order';
import Notification from '../../../../../BaseComponents/Notification';

interface Props {
	prices: RefundPricesFragment | null;
}

const RefundServicesPriceInfo: React.FC<Props> = ({ prices }) => {
	const { t } = useTranslation('RefundServices');

	if (!prices) {
		return null;
	}

	return (
		<div>
			<ExchangeRefundPriceDetails variant="only-total" prices={prices} />

			<Notification
				type="global"
				status="note"
				text={t('Refund will be made to the card used to purchase the ticket within 10 working days')}
			/>
		</div>
	);
};

export default RefundServicesPriceInfo;
